
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as echarts from 'echarts';

@Component
export default class CircleChart extends Vue {
  @Prop({ required: true }) readonly actualArriveNum!: number;
  @Prop({ required: true }) readonly shouldArriveNum!: number;
  @Prop({ required: true }) readonly leaveNumber!: number;
  private chart: echarts.ECharts | null = null;

  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart) {
      this.chart.dispose();
    }
  }

  @Watch('actualArriveNum')
  @Watch('shouldArriveNum')
  @Watch('leaveNumber')
  onPropsChange() {
    this.updateChart();
  }

  private initChart() {
    const container = this.$refs.chartContainer as HTMLElement;
    this.chart = echarts.init(container);
    this.updateChart();
  }

  private updateChart() {
    if (!this.chart) return;

    const option = {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        top: '5%',
        left: 'center',
        textStyle: {
          color: '#fff',
          fontSize: 18,
        }
      },
      series: [
        {
          type: 'pie',
          radius: ['40%', '60%'],
          center: ['50%', '50%'],
          avoidLabelOverlap: false,
          startAngle: 300,
          label: {
            show: true,
            position: 'center',
            fontSize: 20,
            fontWeight: 'bold',
            color: '#ffffff',
            formatter: [
              this.actualArriveNum,
              '{b|已打卡}'
            ].join('\n'),
            rich: {
              a: {
                fontSize: 32,
                fontWeight: 'bold',
                color: '#ffffff'
              },
              b: {
                fontSize: 16,
                color: 'rgba(255, 255, 255, 0.6)',
                padding: [5, 0, 0, 0]
              }
            }
          },
          color: ['#00ff00', '#ffffff', '#0000ff'], // Green, White, Blue
          emphasis: {
            scale: false
          },
          labelLine: {
            show: false
          },
          data: [
            {
              value: this.actualArriveNum,
              name: '已打卡',
              label: {
                show: true,
                position: 'outside',
                formatter: '{b|已打卡}\n{c}人',
                rich: {
                  b: {
                    fontSize: 14,
                    color: '#fff',
                    fontWeight: 'bold'
                  }
                }
              },
              labelLine: {
                show: true,
                length: 20,
                length2: 30,
                lineStyle: {
                  color: 'rgba(255, 255, 255, 0.5)'
                }
              },
              itemStyle: {
                color: '#00ff00' // Solid green for checked-in
              }
            },
            {
              value: this.shouldArriveNum,
              name: '未打卡',
              label: {
                show: true,
                position: 'outside',
                formatter: '{b|未打卡}\n{c}人',
                rich: {
                  b: {
                    fontSize: 14,
                    color: '#ffffff',
                    fontWeight: 'bold'
                  }
                }
              },
              labelLine: {
                show: true,
                length: 20,
                length2: 30,
                lineStyle: {
                  color: 'rgb(255, 255, 255)'
                }
              },
              itemStyle: {
                color: '#ffffff' // Solid white for not checked-in
              }
            },
            {
              value: this.leaveNumber,
              name: '请假',
              label: {
                show: true,
                position: 'outside',
                formatter: '{b|请假人数}\n{c}人',
                rich: {
                  b: {
                    fontSize: 14,
                    color: '#ffffff',
                    fontWeight: 'bold'
                  }
                }
              },
              labelLine: {
                show: true,
                length: 20,
                length2: 30,
                lineStyle: {
                  color: 'rgb(255, 255, 255)'
                }
              },
              itemStyle: {
                color: '#0000ff' // Solid blue for on leave
              }
            },
          ]
        },
        {
          type: 'scatter',
          coordinateSystem: 'none',
          data: Array.from({ length: 3 }).map((_, i) => {
            const angle = (i * 120 + 300) % 360;
            const radian = angle * Math.PI / 180;
            return {
              value: [50 + 95 * Math.cos(radian)]
            }
          })
        }
      ]
    };

    this.chart.setOption(option);
  }

  private handleResize() {
    if (this.chart) {
      this.chart.resize();
    }
  }
}
